import React from "react";
import { Layout, Row } from "antd";
import Sidebar from "../../Components/Sidebar/Sidebar";
import DashboardHeader from "../../Components/Header/DashboardHeader";
import IntegrationAPIParams from "../../Components/IntegrationAPIParams/IntegrationAPIParams";
import IntegrationAPIRestPoints from "../../Components/IntegrationAPIRestPoints/IntegrationAPIEndPoints";
import "./Integrations.css";
import { IntegrationsVar } from "../../Utils/variables";
const {heading} = IntegrationsVar

const { Header, Footer, Sider, Content } = Layout;

const Integrations = () => {
  return (
    <>
      <div className="integration-div1 p20">
      <h1 className="pageHead">{heading}</h1>
        <div className="IAPIParams-div">
          <IntegrationAPIParams />
        </div>
        <div className="IAPIEP-div">
          <IntegrationAPIRestPoints />
        </div>
      </div>
    </>
  );
};

export default Integrations;
